import { IYearMonth } from '@/coreDomainsModule/date';

export const COLUMN_NAME_FORECAST_DIFF = ['lastMonthAmount', 'currentMonthAmount', 'diffAmount'] as const;

/**
 * 内示前月差異の列タイプ
 */
export type ForecastDiffColumnTypes = (typeof COLUMN_NAME_FORECAST_DIFF)[number];

/**
 * 引数が内示前月差異の列名かどうか
 * @param arg - 列名
 */
export const isColumnNamesOfForecastDiff = (arg: string): arg is ForecastDiffColumnTypes => {
  return COLUMN_NAME_FORECAST_DIFF.some((column) => column === arg);
};

/**
 * 数量差異の状態
 */
export type DiffAmountType = 'up' | 'down' | 'equal';

/**
 * 内示前月差異のソートとしてapiに渡す情報
 */
export interface ICustomerForecastDiffLastMonthSortInfo {
  sortTargetYearMonth?: IYearMonth;
  sortKey?: string;
}
